import { IFormJBPHPContactRoles } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { CreateHpContact } from '../createHpContact/CreateHpContact'

import styles from './RoleName.module.scss'

interface IRoleNameProps {
  role: string
  partnerId: string
  leadPbmId: number
  allRoles: IFormJBPHPContactRoles[]
  crudKey: string
  fetchPartnerRoles: (value: boolean) => Promise<IFormJBPHPContactRoles[]>
  onUpdateWizard: () => void
}

export const RoleName = ({
  role,
  partnerId,
  leadPbmId,
  allRoles,
  crudKey,
  fetchPartnerRoles,
  onUpdateWizard,
}: IRoleNameProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.role}>{role}</div>
      <CreateHpContact
        partnerId={partnerId}
        allRoles={allRoles}
        leadPbmId={leadPbmId}
        role={role}
        crudKey={crudKey}
        fetchPartnerRoles={fetchPartnerRoles}
        onUpdateWizard={onUpdateWizard}
      />
    </div>
  )
}
